import { PopoverPosition } from '../../popover/PopoverSurface'
import { RefObject } from "react"
import { createStoreContext } from "reusable/mobx-store-utils/storeUtils"
import DateUtils from "@gap/utils/date-utils"
import { makeAutoObservable } from 'mobx'

interface GapDateStoreProps {
   attributes: Record<string, string> | undefined
   updateMdastNode: (node: any) => void
   chipRef: RefObject<HTMLSpanElement>
}

export default class GapDateStore {
   sp
   popover: PopoverPosition | null = null

   constructor(sp: GapDateStoreProps) {
      makeAutoObservable(this)
      this.sp = sp
   }

   get label() {
      return this.sp.attributes?.date ? DateUtils.formatDateLabel(this.sp.attributes?.date) : 'Pick a date…'
   }

   handleChipMouseDown = (e: React.MouseEvent) => {
      e.preventDefault()
      e.stopPropagation()
      const el = this.sp.chipRef.current
      if (!el) return
      const r = el.getBoundingClientRect()
      this.popover = { left: r.left, top: r.top, bottom: r.bottom }
   }

   handlePicked = (iso: string) => {
      this.sp.updateMdastNode({ attributes: { ...this.sp.attributes, date: iso } })
      this.popover = null
   }

   handleClose = () => {
      this.popover = null
   }

}

export const { Provider: GapDateStoreProvider, useProvidedStore: useGapDateStore } = createStoreContext(GapDateStore)
